// extracted by mini-css-extract-plugin
export var TrustPilot = "styles-module--TrustPilot--9be83";
export var content = "styles-module--content--653ee";
export var greenBg = "styles-module--greenBg--e07c2";
export var heart = "styles-module--heart--25ada";
export var reviewsContainer = "styles-module--reviewsContainer--97104";
export var title = "styles-module--title--9de89";
export var visible = "styles-module--visible--5bc3c";